import { ReportApi } from '../api/report'

export const {
  useGetTemplatesQuery,
  useCreateReportMutation,
  useDeleteReportMutation,
  useDeleteTemplateMutation,
  useRegenerateReportMutation,
  useCreateTemplateMutation,
  useUpdateTemplateMutation,
  useGetReportsQuery,
  useGetReportByIdQuery,
  useGetPatientHealthRecordQuery,
  useUpdateReportMutation,
  useUpdateWithTemplateMutation,
} = ReportApi
